import React from 'react';
import {useFormContext} from "react-hook-form";
import Grid from "@mui/material/Grid";
import {QuestionWithMultipleOption} from "../../../../widgets/inputs/QuestionWithMultipleOption";
import {Divider, Typography} from "@mui/material";
import {useForceUpdate} from "../../../../widgets/utils/useForceUpdate";
import CustomText from "../../../../widgets/inputs/CustomText";
import {numberRegister, numberRegisterNone} from "../../../../../utils/RegisterUtils";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {getScoreColor} from "../../detail/QuarantenaCard";

export function calcPunteggioIsolamento(data) {
	let result = 1;
	
	if (data["alterazioneGusto"] && data["alterazioneGusto"] === "true") result = 1;
	if (data["alterazioneOlfatto"] && data["alterazioneOlfatto"] === "true") result = 1;
	
	if (data["vertigini"] && (data["vertigini"] === "true" || data["vertigini"] === true)) result = 2;
	if (data["doloriMuscolari"]) result = 2;
	if (data["inappetenza"]) result = 2;
	if (data["malessereGenerale"]) result = 2;
	if (data["cefalea"] && (data["cefalea"] === "true" || data["cefalea"] === true)) result = 2;
	if (data["tosse"] && (data["tosse"] === "true10" || data["tosse"] === true)) result = 2;
	
	if (data["tosse"] && (data["tosse"] === "true15" || data["tosse"] === true)) result = 3;
	if (data["diarrea"] && (data["diarrea"] === "true" || data["diarrea"] === true)) result = 3;
	if (data["malDiGola"] && (data["malDiGola"] === "true" || data["malDiGola"] === true)) result = 3;
	
	if (data["drl"]) result = 4;
	if (data["drr"]) result = 4;
	if (data["drm"]) result = 4;
	
	if (data["febbre"]) {
		let febbre = parseFloat(data["febbre"]);
		if (febbre <= 37.5 && result <= 1) result = 1;
		if (febbre > 37.6 && febbre <= 38.5 && result <= 3) result = 3;
		if (febbre > 38.6 && result <= 4) result = 4;
	}
	
	if (data["saturazioneO2"]) {
		let saturazioneO2 = parseFloat(data["saturazioneO2"]);
		if (saturazioneO2 <= 90 && result <= 4) result = 4;
		if (saturazioneO2 > 90 && saturazioneO2 <= 94 && result <= 3) result = 3;
		if (saturazioneO2 >= 94 && result <= 1) result = 1;
	}
	
	if (data["pressioneArteriosaMax"]) {
		let pressioneArteriosaMax = parseFloat(data["pressioneArteriosaMax"]);
		if (pressioneArteriosaMax < 159 && result <= 1) result = 1;
		if (pressioneArteriosaMax >= 160 && result <= 3) result = 3;
	}
	
	return result;
}

export const MonitoraggioIsolamentoGrid = ({paziente = false}) => {
	const {errors, control, getValues} = useFormContext();
	const classes = BaseStyle();
	const forceUpdate = useForceUpdate();
	
	return (
		<React.Fragment>
			<Grid container spacing={3} className={classes.monitoraggioContainer} onClick={forceUpdate}>
				<Grid item xs={12}>
					<Typography color={"primary"} variant={"h6"}>
						<b>Domande di carattere generale</b>
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<Typography color={"textSecondary"} variant={"subtitle1"}>
						In questa sezione ti verranno richieste domande di carattere generale per verificare la presenza o meno di
						sintomi.
					</Typography>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"1. Presenta tosse?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"tosse"}
						error={errors["tosse"]}
						answers={[
							{
								label: "Tosse molto frequente",
								value: "true15",
								info: paziente ? "Ho più di 15 colpi di tosse al giorno" : "> di 15 colpi al giorno"
							},
							{
								label: "Tosse frequente",
								value: "true10",
								info: paziente ? "Ho più di 10 colpi di tosse al giorno" : "> di 10 colpi al giorno"
							},
							{
								label: "Tosse sporadica",
								value: "0",
								info: paziente ? "Ho meno di 10 colpi di tosse al giorno" : "<= di 10 colpi al giorno"
							},
							{label: "Tosse assente", value: "A", info: paziente ? "Non ho tosse" : "non presente"},
							/*{
							 label: "Non dichiarato",
							 value: "ND",
							 info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							 },*/
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"2. Mal di gola?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"malDiGola"}
						error={errors["malDiGola"]}
						answers={[
							{label: "Presente", value: "true", info: paziente ? "Ho mal di gola" : "Il paziente ha mal di gola"},
							{label: "Assente", value: "A", info: paziente ? "Non ho mal di gola" : "Il paziente non ha mal di gola"},
							/*{
							 label: "Non dichiarato",
							 value: "ND",
							 info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							 },*/
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"3. Presenta difficoltà respiratorie?"}
						subQuestion={"Si intende la \"fame d'aria\", non il raffreddore"}
						control={control}
						autoFocus={true}
						defaultValue={""}
						rules={{required: false}}
						name={"difficoltaRespiratorie"}
						error={errors["difficoltaRespiratorie"]}
						row={false}
						multiple={true}
						answers={[
							{label: "Nel letto", name: "drl", info: "Quando si è nel letto"},
							{label: "Risposo", name: "drr", info: "Quando si è a risposo"},
							{label: "Movimento", name: "drm", info: "Quando si è in movimento"},
							{
								label: "Assente",
								name: "ass",
								info: paziente ? "Non presento difficoltà respiratorie" : "Non presenta difficoltà respiratorie"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"4. Mal di testa o cefalea?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"cefalea"}
						error={errors["cefalea"]}
						answers={[
							{label: "Presente", value: "true", info: paziente ? "Hai mal di testa" : "Il paziente ha mal di testa"},
							{
								label: "Assente",
								value: "A",
								info: paziente ? "Non hai mal di testa" : "Il paziente non ha mal di testa"
							},
							/*{
							 label: "Non dichiarato",
							 value: "ND",
							 info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							 },*/
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"5. Sintomi minori?"}
						subQuestion={"Se non rilevi nessun sintomo, non compilare questa domanda o clicca su assente"}
						control={control}
						autoFocus={true}
						defaultValue={""}
						rules={{required: false}}
						name={"sintomiMinori"}
						error={errors["sintomiMinori"]}
						row={false}
						multiple={true}
						answers={[
							{
								label: "Dolori muscolari",
								name: "doloriMuscolari",
								info: paziente ? "Presento dolori muscolari" : "Il paziente presenta dolori muscolari"
							},
							{
								label: "Malessere",
								name: "malessereGenerale",
								info: paziente ? "Sono in uno stato di malessere generale" : "Il paziente presenta malessere generale"
							},
							{
								label: "Inappetenza",
								name: "inappetenza",
								info: paziente ? "Non ho appetito" : "Il paziente non ha appetito"
							},
							{
								label: "Assente",
								name: "ass",
								info: paziente ? "Non presento sintomi minori" : "Non presenta sintomi minori"
							},
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"6. Diarrea?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"diarrea"}
						error={errors["diarrea"]}
						answers={[
							{
								label: "Sporadica",
								value: "0",
								info: paziente ? "Effettuo più di 3 scariche al giorno" : " < 3 scariche al giorno"
							},
							{label: "Assente", value: "A", info: paziente ? "Non ho la diarrea" : "Il paziente non ha diarrea"},
							/*{
							 label: "Non dichiarato",
							 value: "ND",
							 info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							 },*/
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"7. Vertigini?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"vertigini"}
						error={errors["vertigini"]}
						answers={[
							{label: "Presenti", value: "true", info: paziente ? "Ho le vertigini" : "Il paziente presenta vertigini"},
							{
								label: "Assenti",
								value: "A",
								info: paziente ? "Non ho le vertigini" : "Il paziente non presenta vertigini"
							},
							/*{
							 label: "Non dichiarato",
							 value: "ND",
							 info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							 },*/
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"8. Ha rilevato un' alterazione del gusto?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"alterazioneGusto"}
						error={errors["alterazioneGusto"]}
						answers={[
							{
								label: "Presente",
								value: "true",
								info: paziente ? "Ho rilevato un alterazione del gusto" : "Il paziente ha rilevato un' alterazione del gusto"
							},
							{
								label: "Assente",
								value: "A",
								info: paziente ? "Non ho rilevato un alterazione del gusto" : "Il paziente non ha rilevato un' alterazione del gusto"
							},
							/*{
							 label: "Non dichiarato",
							 value: "ND",
							 info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							 },*/
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<QuestionWithMultipleOption
						question={"9. Ha rilevato un' alterazione dell' olfatto?"}
						control={control}
						autoFocus={true}
						defaultValue={"ND"}
						rules={{required: false}}
						name={"alterazioneOlfatto"}
						error={errors["alterazioneOlfatto"]}
						answers={[
							{
								label: "Presente",
								value: "true",
								info: paziente ? "Ho rilevato un alterazione dell'olfatto" : "Il paziente ha rilevato un' alterazione dell' olfatto"
							},
							{
								label: "Assente",
								value: "A",
								info: paziente ? "Non ho rilevato un alterazione dell'olfatto" : "Il paziente non ha rilevato un' alterazione dell' olfatto"
							},
							/*{
							 label: "Non dichiarato",
							 value: "ND",
							 info: paziente ? "Non lo voglio dichiarare" : "Il paziente non lo vuole dichiarare"
							 },*/
						]}
					/>
				</Grid>
				<Grid item xs={12}>
					<Divider/>
				</Grid>
				<Grid item xs={12}>
					<Grid item xs={12}>
						<Typography color={"primary"} variant={"h6"}>
							<b>Misurazioni</b>
						</Typography>
					</Grid>
					<Grid item xs={12}>
						<Typography color={"textSecondary"} variant={"subtitle1"}>
							{paziente ? "In questa sezione invece ti sono richieste delle misurazioni che dovrai effettuare solo nel" +
								" caso in cui tu possieda gli strumenti necessari per effettuarle. Solo la misurazione della febbre è obbligatoria." : "In questa sezione ti verranno richieste domande " +
								"di carattere generale per verificare la presenza o meno di sintomi."}
						</Typography>
					</Grid>
				</Grid>
				<Grid item xs={12} sm={4}>
					<CustomText
						control={control}
						rules={numberRegister}
						name={"febbre"}
						label={"Febbre"}
						type={"number"}
						error={errors["febbre"]}/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<CustomText
						control={control}
						rules={numberRegisterNone}
						name={"saturazioneO2"}
						label={"Saturazione"}
						type={"number"}
						error={errors["saturazioneO2"]}/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<CustomText
						control={control}
						rules={numberRegisterNone}
						name={"pressioneArteriosaMax"}
						label={"Pressione arteriosa massima"}
						type={"number"}
						error={errors["pressioneArteriosaMax"]}/>
				</Grid>
				<Grid item xs={12}>
					<Divider/>
				</Grid>
				<Grid item xs={12}>
					{!paziente && <Typography variant={"subtitle1"} align={"right"}>
						Score: <b style={{
						color: getScoreColor("Isolamento", [getValues()])
					}}>
						<span
							style={{fontSize: 40}}>{"  " + calcPunteggioIsolamento(getValues())}
						</span> / 4</b>
					</Typography>}
				</Grid>
				{!paziente && <Grid item xs={12}>
					<Divider/>
				</Grid>}
			</Grid>
		</React.Fragment>
	);
};
